const drives = [
    {
        logo: 'SiGoogledrive',
        name: 'Google Drive',
        available: 20,
        total: 50
    },
    {
        logo: 'AiOutlineDropbox',
        name: 'Dropbox',
        available: 15,
        total: 40
    },
    {
        logo: 'FcOpenedFolder',
        name: 'Drive',
        available: 12,
        total: 30
    },
]

const folders = [
    {
        name: 'Design',
        file: 12,
        size: 6
    },
    {
        name: 'Development',
        file: 20,
        size: 8
    },
    {
        name: 'Project A',
        file: 6,
        size: 2
    }
]

const recentFile = [
    {
        name: 'index.html',
        date: '12-10-2020, 09:45',
        size: '09 KB'
    },
    {
        name: 'Project-A.zip',
        date: '11-10-2020, 17:05',
        size: '115 KB'
    },
    {
        name: 'Img-1.jpeg',
        date: '11-10-2020, 13:26',
        size: '86 KB'
    },
    {
        name: 'update list.txt',
        date: '10-10-2020, 11:32',
        size: '08 KB'
    },
    {
        name: 'Project B',
        date: '10-10-2020, 10:51',
        size: '72 KB'
    },
    {
        name: 'Changes list.txt',
        date: '09-10-2020, 17:05',
        size: '07 KB'
    },
    {
        name: 'Img-2.png',
        date: '09-10-2020, 15:12',
        size: '31 KB'
    },
    {
        name: 'Project C',
        date: '09-10-2020, 10:11',
        size: '20 KB'
    },
    {
        name: 'starter-page.html',
        date: '08-10-2020, 03:22',
        size: '11 KB'
    },
]

const storage = [
    {
        name: 'Images',
        file: 176,
        size: 6
    },
    {
        name: 'Video',
        file: 45,
        size: 4.1
    },
    {
        name: 'Music',
        file: 21,
        size: 3.2
    },
    {
        name: 'Document',
        file: 21,
        size: 2
    },
    {
        name: 'Others',
        file: 20,
        size: 1.4
    },
]

export {drives, folders, recentFile, storage}